export const mapTableDataForSyncRequest = (
  checkListTableData,
  changedEntriesIds,
  selectedLang
) => {
  const mappedData = [];
  checkListTableData.forEach((object) => {
    if (changedEntriesIds.includes(object.id)) {
      const data = {
        id: object.id,
        type: object.type,
        language: selectedLang,
      };
      if (object.type === "ITEM") {
        object.groupKeys.forEach((key) => {
          data[key] = object.translations[selectedLang].group.find((x) => x.key === key).value;
        });
      } else {
        const key = object.translations[selectedLang].item.key;
        data[key] = object.translations[selectedLang].item.value;
      }

      mappedData.push(data);
    }
  });

  return mappedData;
};

export const buildAITranslationRequest = (selectedLang, checkListTableData) => {
  const body = {
    targetLanguages: [selectedLang],
    entities: [],
  };
  Object.entries(checkListTableData).forEach(([_, object]) => {
    const shouldBeTranslated = object.translations[selectedLang].item
      ? object.translations[selectedLang].item.value === ""
      : object.translations[selectedLang].group.find((obj) => obj.value === "");
    if (shouldBeTranslated) {
      body.entities.push({
        entityType: object.type,
        entityId: object.id,
        objects: Object.keys(object.baseTranslations).map((key) => {
          return {
            label: key,
            text: object.baseTranslations[key],
          };
        }),
      });
    }
  });

  return body;
};
